import Button from '@mui/material/Button';
import useProperty from '../../property/hooks/useProperty';
import useAddCleaning from '../hooks/useAddCleaning';

const AutoAddCleaningButton = ({ time }: { time: string }) => {
    const { propertyId } = useProperty();
    const addCleaning = useAddCleaning();

    if (!propertyId) {
        return null;
    }

    return (
        <Button
            variant="contained"
            onClick={() => {
                addCleaning(propertyId, time)
                    .catch(error => {
                        throw error;
                    })
                    .finally(() => {
                        window.location.reload();
                    });
            }}
        >
            Add cleaning
        </Button>
    );
};

export default AutoAddCleaningButton;
